// Shared timestamp-column helpers used by every table in this
// schema. Lifted out so sibling schema files
// (`./schema-templates.ts`) can compose the same defaults without
// importing from `./schema.ts` and risking a circular reference.

import { timestamp } from 'drizzle-orm/pg-core'

export const createdAtColumn = () =>
  timestamp('created_at', { withTimezone: true }).notNull().defaultNow()

export const updatedAtColumn = () =>
  timestamp('updated_at', { withTimezone: true }).notNull().defaultNow()
